import { render } from "./content-card-old.vue?vue&type=template&id=29b81a01"
import script from "./content-card-old.vue?vue&type=script&lang=js"
export * from "./content-card-old.vue?vue&type=script&lang=js"

import "./content-card-old.vue?vue&type=style&index=0&id=29b81a01&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__